<template>
    <div class="projects-page">
        <Header />
        <br>
        <br>
        <div v-if="project_data !== null && project_data.is_approved == 1" class="my-5 overflow-hidden position-relative" id="single-project">
            <div id="new-project">
                <b-row>
                    <b-col :lg="hold ? 9: 12" :class="{'px-lg-5':hold }">
                        <b-container>
                            <div class="d-flex">
                                <router-link class="d-flex align-items-center" :to="'/user/' + (project_data.username ? project_data.username : (project_data.submittedBy.split(' ')[0]))">
                                    <b-avatar :src="project_data.profile_img" variant="secondary" size="3rem"></b-avatar>
                                    <div class="d-flex flex-column align-items-start ml-2">
                                        <div class="h5 mb-0" style="font-weight:600" v-if="project_data.username">{{ project_data.username }}</div>
                                        <div class="h5 mb-0" v-else>{{ project_data.submittedBy }}</div>
                                        <div class="text-muted">{{ project_data.creation_date | formatDate }}</div>
                                    </div>
                                </router-link>
                                <div v-if="!hold" class="ml-auto views" @click="hold = !hold">
                                    <b-icon icon="eye-fill"></b-icon>
                                    <span class="ml-2">{{ project_data.views }}</span>
                                </div>
                            </div>
                            <br>
                            <div class="slideshow  black-arrows" v-if="project_data.uploads !== null || project_data.youtube_link !== null">
                                <VueSlickCarousel v-bind="settings">
                                    <div v-for="(item, index) in project_data.uploads" :key="index" class="carousel-img">
                                        <img v-if="isImg(item)" :src="item.url" alt="img" class="img-fluid w-100 d-block slideshow__image">
                                        <video v-else controls class="slideshow__video">
                                            <source :src="item.url">
                                        </video>
                                    </div>
                                    <div v-if="project_data.file && project_data.file.includes('.mp4')"  class="carousel-img">
                                        <video controls class="slideshow__video">
                                            <source :src="'https://avishkaar-users.s3.amazonaws.com/' + project_data.file">
                                        </video>
                                    </div>
                                    <div class="embed-responsive embed-responsive-16by9 slideshow__youtube" v-if="youtubeId">
                                        <iframe class="embed-responsive-item" :src="youtubeId"></iframe>
                                    </div>
                                    <div v-if="project_data.third_party !== null ? (project_data.third_party.includes('https://studio.code.org/projects/applab/') ? true : false) : false">
                                        <iframe width="392" height="620" style="border: 0px;" :src="project_data.third_party + '/embed'"></iframe>
                                    </div>
                                </VueSlickCarousel>
                            </div>
                            <br>
                            <h1 class="h3 my-4 text-left project-title">{{ project_data.project_title }}</h1>
                            <div class="h6 text-left text-dark">
                                {{ project_data.description }}
                            </div>
                        </b-container>
                        <section class="details text-left position-relative">
                            <b-container>
                                <div class="h5 mb-3 font-weight-bolder" v-if="kitsUsed != ''">Kits Used</div>
                                    <b-row>
                                        <b-col tag="a" :href="item.uri" lg="3" md="6" sm="12" class="mb-3" v-for="(item, index) in kitsUsed" :key="index">
                                            <div class="details__kit-box h-100" :style="{ border: '1px solid #' + item.color }">
                                                <div class="details__skill-name" :style="{ border: '1px solid #' + item.color, background: '#' + item.color }" style="border-top-left-radius: 3px; border-top-right-radius: 3px">
                                                    {{ item.skill }}
                                                </div>
                                                <img class="details__kit-img m-3" :src="item.src" alt="" width="60px" height="60px">
                                                <div class="details__kit-name">
                                                    {{ item.name }}
                                                </div>
                                            </div>
                                        </b-col>
                                    </b-row>
                                <div class="details__kits-used" style="border-bottom: 1px solid #eeeeee;">
                                    <br>
                                    <div v-if="this.project_data.collabratorsAvatar != ''" class="details__collaborators" style="border-top: 1px solid #eeeeee">
                                        <div class="h5 mb-3 mt-3 font-weight-bolder">Collaborators</div>
                                        <b-row>
                                            <b-col cols="4" lg="2" v-for="(item,index) in project_data.collabratorsAvatar" :key="index" class="details__collaborators-column">
                                                <b-avatar variant="secondary" size="6rem" :src="item.avatar"></b-avatar>
                                                <div class="h5 details__collaborators-name my-2">{{ item.username }}</div>
                                                <div class="view-profile-btn">
                                                    <router-link :to="'/user/' + item.username">
                                                        View Profile
                                                    </router-link>
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </div>
                                    <br>
                                    <div v-if="(project_data.third_party !== null ? (project_data.third_party.includes('https://avishkaar-users.s3.amazonaws.com') ? true : false) : false) || (project_data.project_codes ? true : false)" class="h5 mb-3 font-weight-bolder">Code</div>
                                    <a v-if="project_data.third_party !== null ? (project_data.third_party.includes('https://avishkaar-users.s3.amazonaws.com') ? true : false) : false" :href="project_data.third_party" style="display:flex;align-items:center;font-size:1.125rem;color:#F36F2E">
                                        <img style="margin-right:1rem" src="https://images.avishkaar.cc/misc/projects/code.png" alt="Code" />
                                        <div>Download</div>
                                    </a>
                                    <a target="_blank" :href="`https://www.avishkaar.cc/ams_web/amsReact/api/share.php?id=${project_data.project_codes.split('#split#')[1]}`" v-if="project_data.project_codes ? true : false" style="display:flex;align-items:center;font-size:1.125rem;color:#F36F2E">
                                        <img style="margin-right:1rem" src="https://images.avishkaar.cc/misc/projects/code.png" alt="Code" />
                                        <div>{{project_data.project_codes.split('#split#')[0]}}</div>
                                    </a>
                                    <br>
                                    <div v-if="tags[0] !== ''" class="h5 mb-3 font-weight-bolder">Tags</div>
                                    <div v-if="tags[0] !== ''" class="d-flex flex-wrap">
                                        <div class="tag-chip" v-for="(item, index) in tags" :key="index">{{ item }}</div>
                                    </div>
                                </div>
                            </b-container>
                            <div v-if="showMore" class="avishkaar-logo">
                                <b-img-lazy src="@/assets/images/logo.png" alt="avishkaar logo" fluid height="400" width="400"></b-img-lazy>
                            </div>
                        </section>
                    </b-col>
                </b-row>
            </div>
            <b-row :class="hold ? 'densed': ''" class="other-projects">
                <b-col :lg="hold ? 9: 12">
                    <section v-if="project_data.otherResult" id="your-other-projects" style="background-color: #9BC157;">
                        <b-container :class="{'px-lg-5':hold }">
                            <h2 class="text-white h5 text-left">
                                More projects by
                                <span v-if="project_data.username">{{ project_data.username }}</span>
                                <span v-else>{{ project_data.submittedBy }}</span>
                            </h2>
                            <VueSlickCarousel v-bind="settingsBox">
                                <div v-for="item in project_data.otherResult" :key="item.project_id">
                                    <ProjectBox :project="item" />
                                </div>
                            </VueSlickCarousel>
                        </b-container>
                    </section>
                    <section class="black-arrows" id="similar-projects" v-if="project_data.similarResult">
                        <b-container :class="{'px-lg-5':hold }">
                            <h2 class="h5 text-left">Similar Projects</h2>
                            <VueSlickCarousel v-bind="settingsBox">
                                <div v-for="item in project_data.similarResult" :key="item.project_id">
                                    <ProjectBox :project="item" />
                                </div>
                            </VueSlickCarousel>
                        </b-container>
                    </section>
                </b-col>
            </b-row>
            <div class="card rounded-0 shadow-sm views-card" :class="hold ? 'd-block' : 'd-none'">
                <div class="card-body d-flex align-items-center">
                    <div class="h5 text-left mb-0 font-weight-bold mt-3">Project Views ({{ project_data.views }})</div>
                    <div class="ml-auto times-icon" @click="hold = false">
                        <b-icon icon="X" scale="2"></b-icon>
                    </div>
                </div>
                <ul class="list-group list-group-flush" v-if="project_data.trackDetails">
                    <li class="list-group-item d-flex align-items-center" v-for="item in project_data.trackDetails" :key="item.userId">
                        <div class="d-flex align-items-center font-weight-bold">
                            <b-avatar :src="item.profile_img" size="3rem" class="mr-2"></b-avatar>
                            {{ item.username ? item.username : (item.name.split(' ')[0]) }}
                        </div>
                        
                        <div class="ml-auto view-profile-btn">
                            <router-link :to="'/user/' + (item.username ? item.username : (item.name.split(' ')[0]))">
                                <span class="d-lg-inline d-none">View</span> Profile
                            </router-link>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <b-modal id="project-pending" centered hide-header no-close-on-backdrop>
            <div class="no-approved">
                <span>Your Project Is Still Pending For Approval</span>
                <span>Please check again later</span>
            </div>
            <template #modal-footer="{ ok }">
                <b-button size="md" class="orange-button" @click="ok(); $router.push('/projects');">OK</b-button>
            </template>
        </b-modal>
        <b-modal id="project-disapproved" centered hide-header no-close-on-backdrop>
            <div class="no-approved">
                <span>Your Project Has Been Disapproved</span>
            </div>
            <template #modal-footer="{ ok }">
                <b-button size="md" class="orange-button" @click="ok(); $router.push('/projects');">OK</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import ProjectBox from "@/components/projects/ProjectBox"
import Header from '../components/header.vue'
import axios from "axios";
const BASE_URL = process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "https://localhost:3000";
export default {
    name: "project",
    components: {
        VueSlickCarousel,
        ProjectBox,
        Header
    },
    computed: {
        youtubeId() {
            if (this.project_data.youtube_link) {
                let regExp = /.*(?:youtu.be\/|v\/|shorts\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/;
                let match = this.project_data.youtube_link.match(regExp);
                if (match && match[1].length == 11) {
                return `https://www.youtube.com/embed/${match[1]}`;
                } else {
                return false;
                }
            } else {
                return false;
            }
        },
        tags() {
            if (this.project_data !== null && typeof this.project_data.tags === "string") {
                const list = this.project_data.tags.split(",");
                return list
            }
            return []
        },
        kitsUsed() {
            if (this.project_data !== null && typeof this.project_data.kits_used === "string") {
                const list = this.project_data.kits_used.split(",");
                const kits = []
                for (let element of list) {
                    for (let item of this.kits) {
                        if (item.name === element) {
                            kits.push(item)
                            break;
                        }
                    }
                }
                return kits
            }
            return []
        },
        collabrators() {
            if (this.project_data !== null && typeof this.project_data.collabrators === "string") {
                const list = this.project_data.collabrators.split(",");
                return list
            }
            return []
        }
    },
    mounted() {
        const w = window.innerWidth;
        if (w < 578) {
            this.hold = false;
        }

        if(this.$cookies.get('userAccess')) {
            const payload = {
                projectUri: this.$route.params.code
            }
            axios.post(BASE_URL + "/projects/track/" + this.$route.params.code, payload)
            .then(({ data }) => {
                
            })
            .catch(error => {
                console.log(error);
            })
        }
        

        axios.get(BASE_URL + "/projects/uri/" + this.$route.params.code)
        .then(({ data }) => {
            this.project_data = data.data;
            if (data.data.is_approved == null) this.$bvModal.show('project-pending');
            if (data.data.is_approved == 0) this.$bvModal.show('project-disapproved');
        })
        .catch(error => {
            console.log(error);
        })

        axios.get(BASE_URL + "/products/category/product")
        .then(({ data }) => {
            for (let item of data.data) {
                this.kits.push({
                    name: item.product_name,
                    src: item.image,
                    color: item.skill.skill_color,
                    skill: item.skill.skill_name,
                    uri: 'https://shop.avishkaar.cc/products/' + item.product_uri
                })
            }
        })
    },
    data() {
        return {
            hold: true,
            views: [],
            project_data: null,
            kits: [],
            pending: false,
            showMore: false,
            settings: {
                "arrows": true,
                "dots": false,
                "slidesToShow": 1,
                "slidesToScroll": 1,
                "responsive": [
                    {
                        "breakpoint": 1200,
                        "settings": {
                            "arrows": true,
                            "dots": false,
                            "slidesToShow": 1,
                            "slidesToScroll": 1,
                        }
                    },
                    {
                        "breakpoint": 768,
                        "settings": {
                            "arrows": false,
                            "dots": true,
                            "slidesToShow": 1,
                            "slidesToScroll": 1,
                        }
                    }
                ]
            },
            settingsBox: {
                "arrows": true,
                "dots": false,
                "infinite": false,
                "slidesToShow": 4,
                "slidesToScroll": 4,
                "responsive": [
                    {
                        "breakpoint": 1200,
                        "settings": {
                            "arrows": true,
                            "dots": false,
                            "slidesToShow": 3,
                            "slidesToScroll": 3,
                        }
                    },
                    {
                        "breakpoint": 768,
                        "settings": {
                            "arrows": true,
                            "dots": false,
                            "slidesToShow": 2,
                            "slidesToScroll": 2,
                        }
                    },
                    {
                        "breakpoint": 578,
                        "settings": {
                            "arrows": false,
                            "dots": false,
                            "slidesToShow": 1,
                            "slidesToScroll":1,
                            "centerMode": true,
                            "centerPadding": "20px",
                            
                        }
                    }
                ]
            }
        }
    },
    methods: {
        isImg(item) {
            if (item.url.includes('.png')) {return true}
            else if (item.url.includes('.jpg')) {return true}
            else if (item.url.includes('.jpeg')) {return true}
            else {return false}
        }
    },
    
}
</script>

<style lang="scss" scoped>
$orange-color: #DF711B;
.view-profile-btn {
    & a {
        color: $orange-color !important;
        font-weight: 600;
        font-size: 0.9rem;
    }
}
section {
    padding: 3rem 0;
}
.tag-chip {
    background: $orange-color;
    border: 1px solid $orange-color;
    border-radius: 20px;
    padding: 0.5rem 1rem;
    color: white;
    margin-bottom: 1rem;
}
.tag-chip:not(:last-child) {
    margin-right: 1rem;
}
.views {
    cursor: pointer;
}
.views-card {
    position: fixed;
    right: 0;
    top: 9%;
    width: 25%;
    height: 100vh;
    overflow: scroll;
}
.times-icon {
    cursor: pointer;
}
@media only screen and (max-width: 767px) {
    .views-card {
        width: 50%;
    }
}

.slideshow {
    &__image {
        width: auto;
        height: 400px;
        object-fit: contain;
        max-height: 400px;
    }
    &__video {
        width: auto;
        height: 400px;
        max-height: 400px;
        object-fit: contain;
    }
    &__youtube {
        width: 80%!important;
        height: 400px;
        max-height: 400px;
        object-fit: contain;
    }
    @media screen and (max-width: 768px) {
        &__video {
            width: 100%;
            height: 400px;
        }
        &__youtube {
            width: 100%!important;
            height: 400px;
        }
    }
}

.no-approved {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 20vh;
  padding: 0.5rem;
  font-size: 1.25rem;
  color: #f36f2e;
  font-family: Poppins;
  font-weight: 500;
  @media screen and (max-width: 768px) {
    font-size: 1rem;
    text-align: center;
    align-items: center;
    justify-content: space-evenly;
  }
}
.orange-button {
  font-family: Roboto;
  outline: 0;
  font-size: 1rem;
  font-weight: 500;
  background: #f36f2e;
  box-shadow: 0px 2px 2px rgb(0 0 0 / 12%);
  border: 1px solid #f36f2e;
  box-sizing: border-box;
  border-radius: 30px;
  color: white;
}

.details {
    &__collaborators-column {
        text-align: center;
    }
    &__collaborators-column:not(:last-child) {
        border-right: 1px solid #aaa;
    }
    &__btn {
        color: $orange-color !important;
        font-size: 1.2rem;
        cursor: pointer;
    }
    &__collaborators {
        position: relative;
    }

    &__collaborators-name {
        text-align: center;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    &__collaborators-photo {
        width: 10rem;
        height: 10rem;
    }
    &__overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.7);
        display: block;
    }

    &__kit-box {
        text-align: center;
        border-radius: 5px;
        padding-bottom: 0.5rem;
    }

    &__kit-img {
        height: 6.5rem;
        width: 6.5rem;
        margin-top: .5rem;
    }

    &__kit-name {
        font-weight: 700;
    }

    &__skill-name {
        color: white;
        padding: 0.5rem;
        border-top-left-radius: 2px;
        border-top-right-radius: 2px;
        font-weight: 700;
    }
}

.details__overlay.details__transparent {
    display:none;
}

.avishkaar-logo {
    position: absolute;
    top: 40%;
    right: 0%;
    transform: translate(0, -50%);
    z-index: -1;
}
.project-title {
    font-weight: 600;
}
</style>